import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {StudijnyPlan} from '../model/StudijnyPlan';
import {StudijnyPlanItem} from '../model/StudijnyPlanItem';
import {PredmetPonuka} from '../model/PredmetPonuka';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-studijny-plan',
    templateUrl: './studijny-plan.component.html',
    styleUrls: ['./studijny-plan.component.css'],
    standalone: false
})
export class StudijnyPlanComponent implements OnInit, OnDestroy {
  predmety: StudijnyPlanItem[];
  studijnyPlan = true;
  ponukaPredmetov: PredmetPonuka[];
  value: any;
  truncatedSearch = false;
  helpVisible = false;
  pocetPredmetov = 0;
  filtrovanaPonukaPredmetov: PredmetPonuka[] = [];
  loader = false;
  private ponukaPredmetovSubscription: Subscription;
  private ponukaPredmetovLoaderSubscription: Subscription;
  red: any;
  absolvovane = false;

  @ViewChild('searchInput') searchInput: ElementRef;

  protected filteredPredmety: StudijnyPlanItem[];

  constructor(
    public dialogRef: MatDialogRef<StudijnyPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {studijnyPlan: StudijnyPlan},
    private http: HttpClient,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.predmety = this.data.studijnyPlan.predmety;
    this.getPonukaPredmetov();

    this.loader = this.appService.getPredmetyPonukaLoader();

    this.ponukaPredmetovSubscription = this.appService.predmetyPonukaSubject
      .subscribe((data: PredmetPonuka[]) => {
          this.ponukaPredmetov = data;
        });

    this.ponukaPredmetovLoaderSubscription = this.appService.predmetyPonukaLoadingSubject
      .subscribe((data: boolean) => {
          this.loader = data;
      });

    this.red = this.appService.getRed();

    this.appService.fetchPredmetyPonuka();
  }

  saved(p: StudijnyPlanItem) {
    if (p.cast.kod !== 'VC' && p.cast.kod !== 'DA') {
      this.predmety = this.predmety.filter(i => i.idPredmetRok !== p.idPredmetRok);
    }
  }

  getPonukaPredmetov() {

    if (this.ponukaPredmetov == null) {
      this.ponukaPredmetov = this.appService.getPredmetyPonuka();
    }

    let res: any[];

    if (this.value && this.value !== '') {
      res = this.ponukaPredmetov.filter(
        (i) => {
          const normalizedValue = this.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          return i.nazov.indexOf(this.value) >= 0 || i.search.indexOf(normalizedValue) >= 0;
        });
      this.pocetPredmetov = res.length;
    }
    else {
      res = []; // this.ponukaPredmetov;
      this.pocetPredmetov = 0;
    }

    this.truncatedSearch = res && res.length > 50;

    if (res) {
      this.filtrovanaPonukaPredmetov = res.slice(0, 50);
    }
    else {
      this.filtrovanaPonukaPredmetov = [];
    }
  }

  switchToPonuka() {
    this.studijnyPlan = false;
    setTimeout(() => this.searchInput.nativeElement.focus(), 0);
  }

  ngOnDestroy(): void {
    this.ponukaPredmetovSubscription.unsubscribe();
    this.ponukaPredmetovLoaderSubscription.unsubscribe();
  }

  onStudijnyPlanClick() {
    this.studijnyPlan = true;
    this.value = '';
    this.getPonukaPredmetov();
  }

  getFilteredPredmety() {
    this.filteredPredmety = this.predmety;

    if (this.absolvovane === false) {
      this.filteredPredmety = this.predmety.filter(i => i.absolvovany === null);
    }

    return this.filteredPredmety;
  }
}
